import { useState, useEffect } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import methods from "../../services/utility";
import apiMethod from "../../services/api-service";
import Preloading from "../../components/basics/Preloading";
import DeleteModal from "../../components/deleteModal/DeleteModal";
import Joyride from "react-joyride";

// assets
import NoBranches from "../../assets/images/img/NoBranches.svg";
import DashboardHeader from "../../components/header/DashboardHeader";
import ImageCropper from "../../components/crop/ImageCropper";
import LogoCropper from "../../components/crop/LogoCropper";

const Dashboard = () => {
  const [gridData, setGridData] = useState([]);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [isLogoUploading, setIsLogoUploading] = useState(false);
  const [formModel, setFormModel] = useState({
    title: "",
    supervisor: "",
    tels: "",
    address: "",
    description: "",
    provinceId: "",
    cityId: "",
    imgSrc: "",
    logo: "",
    restaurantId: 0,
    id: 0,
    nationalID: "",
    companyName: "",
    economicID: "",
    zipCode: "",
  });
  const navigate = useNavigate();
  const isUserLogedin = methods.checkUserLogin();
  const [restaurant, setRestaurant] = useState({
    id: 0,
    title: "",
    packageId: 0,
    maxBranch: 0,
    expirationDate: "",
    createDate: "",
  });
  const [showTour, setShowTour] = useState(false);
  const steps = [
    {
      target: ".dashboardtitle",
      content:
        "به نرم‌افزار مدیریت رستوران‌ها خوش آمدید! از اینجا می‌توانید تمام بخش‌های نرم‌افزار را مدیریت کنید.",
      disableBeacon: true,
    },
    {
      target: "#userProfile",
      content: "اطلاعات کاربری خود را در اینجا به‌روزرسانی کنید.",
      disableBeacon: true,
    },
    {
      target: "#creatBranch",
      content:
        "شعبه جدیدی ایجاد کنید. با افزودن شعبه جدید، می‌توانید هر شعبه را به‌صورت جداگانه مدیریت کنید سپس با کلیک بر روی نام شعبه وارد نرم‌افزار فروش شوید.",
      disableBeacon: true,
    },
  ];

  const mapRestarant = (model) => {
    restaurant.id = model.id;
    restaurant.title = model.title;
    restaurant.packageId = model.packageId;
    restaurant.maxBranch = model.maxBranch;
    restaurant.expirationDate = model.expirationDate;
    restaurant.createDate = model.createDate;
  };

  const getUserInfo = async () => {
    setLoading(true);
    const UserBranchesResponse = await apiMethod.getUserBranches();
    mapRestarant(methods.getRestaurantInfo());
    setRestaurant({ ...restaurant });
    formModel.restaurantId = restaurant.id;
    setFormModel({ ...formModel, restaurantId: restaurant.id });
    setGridData(UserBranchesResponse.data);
    setLoading(false);
  };

  const getGridData = async () => {
    const resp = await apiMethod.getUserBranches();
    if (methods.showApiErrors(resp)) setGridData(resp.data);
  };

  const getProvinces = async () => {
    const resp = await apiMethod.getProvinces(1, 50, 1, "");
    if (methods.showApiErrors(resp)) setProvinces(resp.data);
  };

  const getCities = async (provinceId) => {
    const resp = await apiMethod.getCities(provinceId, "", 200, 1);
    if (methods.showApiErrors(resp)) setCities(resp.data);
  };

  const checkUserInAccessList = () => {
    var roles = methods.getUserRoles();
    if (!methods.checkSalesUserRoles(roles)) {
      console.log("access denid");
      navigate("/login");
      return false;
    }
    return true;
  };

  useEffect(() => {
    checkUserInAccessList();
    const hasSeenTour = localStorage.getItem("hasSeenTour");
    getUserInfo();
    getProvinces();
    if (!hasSeenTour) {
      const timer = setTimeout(() => {
        setShowTour(true);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [navigate]);

  const tourEnd = (data) => {
    const { action } = data;
    if (action === "close" || action === "skip" || action === "reset") {
      localStorage.setItem("hasSeenTour", "true");
      setShowTour(false);
    }
  };

  const validForm = () => {
    let errors = [];
    if (methods.isNullOrEmptyString(formModel.title)) {
      errors.push(".عنوان باید مقدار داشته باشد");
    }
    if (methods.isNullOrEmptyString(formModel.provinceId)) {
      errors.push(".استان باید مقدار داشته باشد");
    }
    if (methods.isNullOrEmptyString(formModel.cityId)) {
      errors.push(".شهر باید مقدار داشته باشد");
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const resetForm = () => {
    formModel.id = 0;
    formModel.title = "";
    formModel.supervisor = "";
    formModel.tels = "";
    formModel.description = "";
    formModel.address = "";
    formModel.provinceId = "";
    formModel.cityId = "";
    formModel.imgSrc = "";
    formModel.logo = "";
    // formModel.restaurantId = 0;
    formModel.nationalID = "";
    formModel.companyName = "";
    formModel.economicID = "";
    formModel.zipCode = "";
    setFormModel({ ...formModel });
    setShowFormModal(false);
  };

  const UploadFile = async (file, attributeName) => {
    try {
      const formData = new FormData();
      formData.append("File", file);
      formData.append("FileType", 1);
      const response = await apiMethod.uploadFile(formData);

      // Update formModel with the response data
      setFormModel({ ...formModel, [attributeName]: response.data });
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const changeImage = (fileOrEvent) => {
    let file;
    if (fileOrEvent instanceof File) {
      file = fileOrEvent;
    } else {
      file = fileOrEvent.target.files[0];
    }
    setFormModel({ ...formModel, imgSrc: file });
    setIsImageUploading(true);

    // Upload the file
    UploadFile(file, "imgSrc")
      .then(() => {
        // Stop the loading state when the file is uploaded
        setIsImageUploading(false);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  };

  const changeLogo = (fileOrEvent) => {
    let file;
    if (fileOrEvent instanceof File) {
      file = fileOrEvent;
    } else {
      file = fileOrEvent.target.files[0];
    }

    setFormModel({ ...formModel, logo: file });
    setIsLogoUploading(true);

    // Upload the file
    UploadFile(file, "logo")
      .then(() => {
        // Stop the loading state when the file is uploaded
        setIsLogoUploading(false);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  };

  const editItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getBranchInfo(id);
    if (!methods.showApiErrors(resp)) return false;

    formModel.id = resp.data.id;
    formModel.title = resp.data.title;
    formModel.supervisor = resp.data.supervisor;
    formModel.tels = resp.data.tels;
    formModel.description = resp.data.description;
    formModel.address = resp.data.address;
    formModel.provinceId = resp.data.provinceId;
    formModel.cityId = resp.data.cityId;
    formModel.imgSrc = resp.data.imgSrc;
    formModel.logo = resp.data.logo;
    formModel.restaurantId = resp.data.restaurantId;
    formModel.nationalID = resp.data.nationalID;
    formModel.companyName = resp.data.companyName;
    formModel.economicID = resp.data.economicID;
    formModel.zipCode = resp.data.zipCode;
    setFormModel({ ...formModel });
    setShowFormModal(true);
    setLoading(false);
    getProvinces();
    getCities(formModel.provinceId);
  };

  const createNewItem = async (e) => {
    if (!validForm()) return false;

    setLoading(true);

    try {
      const resp = await apiMethod.createBranch(formModel);

      if (!methods.showApiErrors(resp)) return false;

      await getGridData();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowFormModal(false);
      setCities([]);
    }
  };

  const selectَItemToDelete = (branch) => {
    setFormModel(branch);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.deleteBranch(formModel.id);
      if (!methods.showApiErrors(resp)) return false;

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const closeModal = () => {
    resetForm();
    setShowFormModal(false);
    setCities([]);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const openModal = () => {
    resetForm();
    getProvinces();
    setShowFormModal(true);
  };

  const goToBranch = (branch) => {
    navigate(`/sale/${branch.id}`);
  };

  const renderItems = () => {
    return (
      <div className="branches col-12 mt-3">
        {loading && <Preloading></Preloading>}
        {
          <div className="mx-auto">
            <div className="dashboardtitle">
              به رستوران {restaurant.title} خوش آمدید.
            </div>
            <div className="d-flex flex-column flex-sm-column-reverse flex-md-row justify-content-md-between align-items-md-baseline my-2">
              {gridData ? (
                <p>شعبه مورد نظر خود را انتخاب کنید :</p>
              ) : (
                <p>شما تاکنون شعبه ای اضافه نکرده اید .</p>
              )}
              <button
                type="button"
                id="creatBranch"
                onClick={openModal}
                className="btn btn-outline-purple custome-btn d-flex align-items-center justify-content-center"
              >
                شعبه جدید
                <span className="ms-1">
                  <i className="bi bi-plus-circle align-middle"></i>
                </span>
              </button>
            </div>
            <div className="row">
              {!gridData && (
                <div className="d-flex justify-content-center">
                  <img src={NoBranches} alt={NoBranches} className="" />
                </div>
              )}
              <div className="row row-cols-1 row-cols-md-3 g-2 mt-0">
                {gridData.map((branch) => (
                  <div className="col" key={branch.id}>
                    <div className="card">
                      <div className="card-body">
                        <div
                          className="branchCardImg"
                          style={{
                            backgroundImage: `url(${methods.normalImage(
                              branch.imgSrc,
                              "branch"
                            )})`,
                          }}
                        ></div>
                        <button
                          type="button"
                          id="branchTitle"
                          className="btn custome-btn btn-link-purple w-100 mt-3"
                          onClick={() => goToBranch(branch)}
                        >
                          {branch.title}
                        </button>
                      </div>
                      <hr className="mx-3 mb-1 mt-0" />
                      <div className="d-flex justify-content-between align-items-center mx-2 mb-1 mt-0">
                        <button
                          type="button"
                          className="btn custome-btn CardDeleteBtn"
                          onClick={() => selectَItemToDelete(branch)}
                        >
                          حذف
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-trash"
                            viewBox="0 0 16 16"
                          >
                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                          </svg>
                        </button>
                        <button
                          type="button"
                          className="btn custome-btn btn-link-green"
                          onClick={() => editItem(branch.id)}
                        >
                          ویرایش
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-pencil-square"
                            viewBox="0 0 16 16"
                          >
                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                            <path d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        }
      </div>
    );
  };

  const Modal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showFormModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">ایجاد / ویرایش شعبه</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <label htmlFor="title" className="form-label required-label">
                    عنوان
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    name="title"
                    value={formModel.title}
                    onChange={(e) => {
                      formModel.title = e.target.value;
                      setFormModel({ ...formModel });
                    }}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="phone" className="form-label">
                    شماره های تماس
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="phone"
                    name="tels"
                    value={formModel.tels}
                    onChange={(e) => {
                      if (methods.validateNumberInput(e.target.value)) {
                        formModel.tels = e.target.value;
                        setFormModel({ ...formModel });
                      }
                    }}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="supervisor" className="form-label">
                    سرپرست شعبه
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="supervisor"
                    name="supervisor"
                    value={formModel.supervisor}
                    onChange={(e) => {
                      formModel.supervisor = e.target.value;
                      setFormModel({ ...formModel });
                    }}
                  />
                </div>
                <div className="col-md-6"></div>
                <div className="col-md-6">
                  <label htmlFor="city" className="form-label required-label">
                    استان
                  </label>
                  <select
                    id="saleUnit"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.provinceId}
                    onChange={(e) => {
                      formModel.provinceId = e.target.value;
                      setFormModel({ ...formModel });
                      getCities(formModel.provinceId);
                    }}
                  >
                    <option value="">انتخاب کنید</option>
                    {provinces.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label htmlFor="city" className="form-label required-label">
                    شهر
                  </label>
                  <select
                    id="saleUnit"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.cityId}
                    onChange={(e) => {
                      formModel.cityId = e.target.value;
                      setFormModel({ ...formModel });
                    }}
                  >
                    <option value="">انتخاب کنید</option>
                    {cities.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6 my-4">
                  <label htmlFor="fileUpload" className="form-label">
                    انتخاب تصویر <br></br>
                    <span style={{ fontSize: "14px" }}>
                      (اندازه استاندارد 600×900 و حداکثر حجم 600kb است.)
                    </span>
                  </label>
                  <div>
                    <ImageCropper changeImage={changeImage} isImageUploading={isImageUploading} imgSrc={formModel.imgSrc} />
                  </div>
                </div>
                <div className="col-md-6 my-4">
                  <label htmlFor="fileUpload" className="form-label">
                    انتخاب لوگو<br></br>
                    <span style={{ fontSize: "14px" }}>
                      (اندازه استاندارد 400×400 و حداکثر حجم 600kb است.)
                    </span>
                  </label>
                  <LogoCropper changeLogo={changeLogo} isLogoUploading={isLogoUploading} logoSrc={formModel.logo} />
                </div>
                <div className="col-md-6">
                  <label htmlFor="address" className="form-label">
                    آدرس
                  </label>
                  <textarea
                    type="text"
                    className="form-control"
                    id="address"
                    name="address"
                    value={formModel.address}
                    onChange={(e) => {
                      formModel.address = e.target.value;
                      setFormModel({ ...formModel });
                    }}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="description" className="form-label">
                    توضیحات
                  </label>
                  <textarea
                    type="text"
                    className="form-control"
                    id="description"
                    name="description"
                    value={
                      formModel.description !== null
                        ? formModel.description
                        : ""
                    }
                    onChange={(e) => {
                      formModel.description = e.target.value;
                      setFormModel({ ...formModel });
                    }}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="companyName" className="form-label">
                    نام شرکت
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="companyName"
                    name="companyName"
                    value={formModel.companyName || ""}
                    onChange={(e) => {
                      formModel.companyName = e.target.value;
                      setFormModel({ ...formModel });
                    }}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="economicID" className="form-label">
                    شماره اقتصادی
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="economicID"
                    name="economicID"
                    value={formModel.economicID || ""}
                    onChange={(e) => {
                      if (methods.validateNumberInput(e.target.value)) {
                        formModel.economicID = e.target.value;
                        setFormModel({ ...formModel });
                      }
                    }}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="nationalID" className="form-label">
                    شماره ثبت / شماره ملی
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="nationalID"
                    name="nationalID"
                    value={formModel.nationalID || ""}
                    onChange={(e) => {
                      if (methods.validateNumberInput(e.target.value)) {
                        formModel.nationalID = e.target.value;
                        setFormModel({ ...formModel });
                      }
                    }}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="supervisor" className="form-label">
                    کدپستی
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="supervisor"
                    name="supervisor"
                    value={formModel.zipCode || ""}
                    onChange={(e) => {
                      if (methods.validateNumberInput(e.target.value)) {
                        formModel.zipCode = e.target.value;
                        setFormModel({ ...formModel });
                      }
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple "
                onClick={closeModal}
              >
                انصراف
              </button>
              {isImageUploading || isLogoUploading ? (
                <button
                  type="submit"
                  className="btn custome-btn btn-purple"
                  disabled
                >
                  ثبت وذخیره
                </button>
              ) : (
                <button
                  type="submit"
                  className="btn custome-btn btn-purple"
                  onClick={() => {
                    createNewItem();
                  }}
                >
                  ثبت وذخیره
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {isUserLogedin ? (
        <>
          {<DashboardHeader />}
          {renderItems()}
          {showFormModal && Modal()}
          {showDeleteModal && (
            <DeleteModal
              showModal={showDeleteModal}
              closeModal={closeDeleteModal}
              deleteItem={deleteItem}
              text={"شعبه"}
            />
          )}
          {showTour && (
            <Joyride
              steps={steps}
              continuous={true}
              styles={{
                options: {
                  arrowColor: "#f1eff6",
                  backgroundColor: "#f1eff6",
                  overlayColor: "rgba(0, 0, 0, 0.5)",
                  primaryColor: "#6A4D99",
                  textColor: "#342947",
                  spotlight: {
                    // backgroundColor: "transparent",
                    spotlightShadow: "0 0 0 rgba(0, 0, 0, 0.5)",
                  },
                },
              }}
              showProgress={true}
              showSkipButton={true}
              locale={{
                back: "قبلی",
                next: "بعدی",
                skip: "رد‌کردن",
                last: "پایان",
              }}
              hideCloseButton={true}
              callback={tourEnd}
            />
          )}
        </>
      ) : (
        <Navigate to="/login" />
      )}
    </>
  );
};

export default Dashboard;
